class QuickJumpBar extends HTMLElement {
    constructor() {
        super();
        this.items = [];
        this.sticky = false;
        this.announcementBarHeight = 0;
    }

    connectedCallback() {
        this.items = this.querySelectorAll('.quick-jump-bar-item');
        this.sticky = this.dataset.sticky === "true";

        this.enableSticky();
        this.attachEvents();
        this.hasAnnouncementBar();
        this.showJumpBar();
    }

    enableSticky() {
        if (this.sticky) {
            document.body.classList.add('header_no_sticky');
        }
    }

    hasAnnouncementBar() {
        const announcementBar = document.querySelector('.announcement-bar-section');
        if (announcementBar) {
            this.announcementBarHeight = announcementBar.offsetHeight;
            window.addEventListener('resize', () => {
                this.announcementBarHeight = announcementBar.offsetHeight;
            });
        }
    }

    inTheArea() {
        const viewportCenter = window.innerHeight / 2 + window.scrollY;

        this.items.forEach(item => {
            const targetId = item.getAttribute('data-target-id');
            if (targetId) {

                const targetElement = document.getElementById(targetId);
                if (targetElement) {

                    const rect = targetElement.getBoundingClientRect();
                    const top = rect.top + window.scrollY;
                    const bottom = rect.bottom + window.scrollY;

                    if (viewportCenter >= top && viewportCenter <= bottom) {
                        item.classList.add('active');
                    } else {
                        item.classList.remove('active');
                    }
                }
            }
        });
    }

    jumpTo(event) {
        const targetId = event.currentTarget.getAttribute('data-target-id');
        const targetElement = document.getElementById(targetId);
        if (targetElement) {

            const offsetTop = this.sticky ? targetElement.offsetTop - this.offsetHeight : targetElement.offsetTop;

            window.scrollTo({
                top: offsetTop - this.announcementBarHeight,
                behavior: 'smooth'
            });

        }
        this.scrollItemToCenter(event.currentTarget);
    }

    scrollItemToCenter(item) {
        const wrapper = this.querySelector('.quick-item-box');
        const wrapperRect = wrapper.getBoundingClientRect();
        const itemRect = item.getBoundingClientRect();
        const wrapperScrollLeft = wrapper.scrollLeft;

        const offsetLeft = itemRect.left - wrapperRect.left + wrapperScrollLeft - (wrapperRect.width / 2) + (itemRect.width / 2);

        wrapper.scrollTo({
            left: offsetLeft,
            behavior: 'smooth'
        });
    }

    scrollToItem(item) {
        const wrapper = item.parentElement;
        const itemRect = item.getBoundingClientRect();
        const wrapperRect = wrapper.getBoundingClientRect();

        const offsetLeft = itemRect.left - wrapperRect.left + wrapper.scrollLeft;
        wrapper.scrollTo({
            left: offsetLeft,
            behavior: 'smooth'
        });
    }

    showJumpBar() {
        const mainContent = document.querySelector('#MainContent');
        const mainProductContainer = mainContent.querySelector('.main-product-container');
        const quickJumpBarSection = document.querySelector('.section-quick-jump-bar');

        if (mainProductContainer && quickJumpBarSection) {
            window.addEventListener('scroll', () => {
                const rect = mainProductContainer.getBoundingClientRect();
                const mainProductContainerBottom = rect.bottom + window.scrollY;

                if (window.scrollY > mainProductContainerBottom) {
                    quickJumpBarSection.classList.add('active');
                } else {
                    quickJumpBarSection.classList.remove('active');
                }
            });
        }
    }

    attachEvents() {
        this.items.forEach(item => {
            item.addEventListener('click', this.jumpTo.bind(this));
            item.addEventListener('click', () => this.scrollToItem(item));
        });

        window.addEventListener('scroll', this.inTheArea.bind(this));
    }
}

customElements.define('quick-jump-bar', QuickJumpBar);
